"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProjectsContext = exports.ProjectsContext = void 0;
const React = __importStar(require("react"));
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const useProjectsProviderValueHook_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/useProjectsProviderValueHook");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
exports.ProjectsContext = React.createContext({});
const useProjectsContext = () => React.useContext(exports.ProjectsContext);
exports.useProjectsContext = useProjectsContext;
const ProjectsProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const projectsProviderValue = (0, useProjectsProviderValueHook_1.useProjectsProviderValue)();
    React.useEffect(() => {
        if (isMounted()) {
            projectsProviderValue.fetchAllProjects();
        }
    }, [isMounted]);
    if (!projectsProviderValue.projectsState.loaded) {
        return React.createElement(PageLoaderComponent_1.default, null);
    }
    return (React.createElement(exports.ProjectsContext.Provider, { value: projectsProviderValue }, props.children));
};
ProjectsProvider.displayName = "ProjectsProvider";
exports.default = ProjectsProvider;
